var map = {
	"./All - FLYER  NURSING. ZAMB.png": 3164,
	"./All - FLYER AGRI. BAGUIO.png": 5480,
	"./All - FLYER AGRI. ZAMB.png": 9715,
	"./All - FLYER HOSPITALITY. BAGUIO.png": 1079,
	"./All - FLYER HOSPITALITY. ZAMB.png": 9478,
	"./All - FLYER NURSING. BAGUIO.png": 4134,
	"./background1-bak4.jpg": 6704,
	"./background1.jpg": 5570,
	"./cook.jpg": 6589,
	"./edu1.jpg": 656,
	"./edu2.jpg": 6430,
	"./edu3.jpg": 9889,
	"./logo.png": 6949,
	"./nurse.jpg": 2956,
	"./training-brief.jpg": 9216,
	"./training3.jpg": 6962,
	"./wap/background1.jpg": 7046,
	"./wap/logo.png": 3736,
	"./work-model.png": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;